"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Answer = void 0;
const typeorm_1 = require("typeorm/browser");
const data_ui_1 = require("../../data-ui");
const layouts_1 = require("../../data-ui/layouts");
const contact_profile_enum_1 = require("../contact-profile-enum");
const job_1 = require("../job");
const answer_status_1 = require("./answer-status");
const order_1 = require("./order");
const order_form_question_1 = require("./order-form-question");
const submission_1 = require("./submission");
let Answer = class Answer {
};
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
        name: 'id',
    }),
    __metadata("design:type", Number)
], Answer.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)('text', {
        nullable: true,
    }),
    __metadata("design:type", String)
], Answer.prototype, "answer", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], Answer.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], Answer.prototype, "updatedAt", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.ManyToOne)(() => order_form_question_1.OrderFormQuestion, {
        nullable: false,
    }),
    __metadata("design:type", order_form_question_1.OrderFormQuestion)
], Answer.prototype, "question", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('uuid', {
        nullable: false,
    }),
    __metadata("design:type", String)
], Answer.prototype, "questionId", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('integer', {
        nullable: true,
        default: null,
        comment: 'Flow step index for repeated flows (0-based), null for non-repeated flows',
    }),
    __metadata("design:type", Number)
], Answer.prototype, "flowStepIndex", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('character varying', {
        name: 'job_api_id',
        nullable: true,
    }),
    __metadata("design:type", String)
], Answer.prototype, "jobApiId", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.SearchField(),
    (0, typeorm_1.ManyToOne)(() => job_1.Job, { createForeignKeyConstraints: false }),
    (0, typeorm_1.JoinColumn)({
        name: 'job_api_id',
        referencedColumnName: 'apiId',
    }),
    __metadata("design:type", job_1.Job)
], Answer.prototype, "job", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('bigint', {
        name: 'order_id',
        nullable: true,
    }),
    __metadata("design:type", Number)
], Answer.prototype, "orderId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => order_1.Order, {
        nullable: false,
    }),
    __metadata("design:type", order_1.Order)
], Answer.prototype, "order", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: answer_status_1.OrderFormAnswerStatusEnum,
        default: answer_status_1.OrderFormAnswerStatusEnum.PROCESSED,
        nullable: false,
    }),
    __metadata("design:type", String)
], Answer.prototype, "status", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => submission_1.Submission, (submission) => submission.answers),
    __metadata("design:type", submission_1.Submission)
], Answer.prototype, "submission", void 0);
Answer = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [contact_profile_enum_1.ContactProfileEnum.PRODUCT, contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER],
    }),
    data_ui_1.DataUi.Name({
        name: 'Answer',
    }),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Entity)({ schema: 'order_intake_forms' })
], Answer);
exports.Answer = Answer;
//# sourceMappingURL=answer.js.map